import React, { useRef, useEffect, useState ,useSpring } from 'react';
import { motion, useMotionValueEvent, useScroll, useTransform } from 'framer-motion';
import Slider from 'react-slick';
import './workProcess.css';

import imageUrl from '../../../assets/images/animationImg1.png';
import mobileImage from '../../../assets/images/deliveryImage1.png';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import workProcessImg1 from '../../../assets/images/workProcessImg1.png';
import workProcessImg2 from '../../../assets/images/workProcessImg2.png';
import workProcessImg3 from '../../../assets/images/workProcessImg3.png';
import workProcessImg4 from '../../../assets/images/workProcessImg4.png';

const texts = [
  {
    mainHeading: 'How it works',
    title: 'Order from your Favourite App Skye Air',
    desc: 'Order from your favourite app whether its food, medicine, or parcels. Simply choose your items, confirm your delivery address, and leave the rest to us.',
    mobileImg: workProcessImg1
  },
  {
    title: 'Our Drone will Pick up your Order from Source Point',
    desc: 'Our drone collects your package directly from the store or warehouse. Once ready, our system dispatches a drone to retrieve the item with precision.',
    mobileImg: workProcessImg2
  },
  {
    title: 'Drone will Drop your Package at Skye Pod & Skye Walker will Collect it',
    desc: 'The drone drops your package at a secure Skye Pod. From there, a Skye Walker picks it up for the final leg of delivery.',
    mobileImg: workProcessImg3
  },
  {
    title: 'Skye Walker will Deliver at your Doorstep',
    desc: 'A Skye Walker delivers your package safely and quickly to your doorstep with real-time tracking for peace of mind.',
    mobileImg: workProcessImg4
  }
];

const WorkProcess = () => {
  const sectionRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 480);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start start', 'end end']
  });

  const top = useTransform(scrollYProgress, () => '100px');
  const left = useTransform(scrollYProgress, [0, 0.05, 0.18], ['50%', '50%', '10px']);
  const transform = useTransform(scrollYProgress, [0, 0.05, 0.18], ['translateX(-50%)', 'translateX(-50%)', 'none']);
  const opacity = useTransform(scrollYProgress, [0.01, 0.01, 0.85, 0.99], [1, 1, 1, 0]);

  const xImage = useTransform(scrollYProgress, [0, 1], [0, 1400]);
  const yImage = useTransform(scrollYProgress, [0, 1], [0, -900]);

    const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 480);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) return;
    return scrollYProgress.onChange((latest) => {
      let idx = 0;
      if (latest > 0.049 && latest <= 0.55) idx = 1;
      else if (latest > 0.55 && latest <= 0.85) idx = 2;
      else if (latest > 0.85) idx = 3;
      setTextIndex(idx);
    });
  }, [scrollYProgress, isMobile]);

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  const content = isMobile ? texts[0] : texts[textIndex];

  return (
    <div ref={sectionRef} className={`pillar-section ${isMobile ? 'mobile' : ''}`}>
      {isMobile ? (
        <div className="pillar-mobile-slider">
          <h1 className="mobile-main-heading capitalize-first-letter">{texts[0].mainHeading}</h1>
          <Slider {...sliderSettings}>
            {texts.map((item, idx) => (
              <div key={idx} className="pillar-slide">
               
                <h2 className="capitalize-first-letter">{item.title}</h2>
                <p>{item.desc}</p>
                <img className="pillar-image mobile-image" src={item.mobileImg} alt="Mobile Slide" />
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <>
          <motion.div
            className="pillar-fixed-text"
            style={{ position: textIndex === 0 ? "absolute" : "fixed", top, left, transform, opacity }}
          >
            {textIndex === 0 && <h1  className="fw-bold capitalize-first-letter">{texts[0].mainHeading}</h1>}
            <h2 className="capitalize-first-letter"  style={{
                fontWeight: 600,
                ...(textIndex === 0 && { padding: '15px 10px 3px' })
              }} >{texts[textIndex]?.title}</h2>
            <p>{texts[textIndex]?.desc}</p>
          </motion.div>
          <motion.img
            className="pillar-image"
            src={imageUrl}
            alt="Pillar Illustration"
            style={{ x: xImage, y: yImage }}
          />
        </>
      )}
    </div>
  );
};

export default WorkProcess;
